import { useEffect, useRef, useState } from "react";
import { SummaryCase } from "../../../models";
import { TeamQContext } from "../types";
import { getCaseCount, getCases, getTeamQStaticData } from "../../../services/get.data.service";
import { displaySettingsAction, PageName } from "../reducers/displaySettingsReducer";

import usePolling from "./usePolling";
import { readLocalStorage, writeLocalStorage } from "./localStorage";
import { getFilterQueryString, getQueryString } from "../helpers/getQueryStrings";
import { CancelTokenSource } from "axios";
import { StaticData } from "../../../models/staticData";

export const useLoadData = (
  context: TeamQContext,
  dataLoad: boolean,
  setCases: (cases: SummaryCase[]) => void,
  setDataLoad: (state: boolean) => void,
  setLoadingCases: (state: boolean) => void,
  setStaticData: (data: StaticData) => void,
  setTotalCasesCount: (count: number|null) => void,
  setMyCasesCount: (count: number|null) => void
): void => {
  const {
    state: { displaySettings, filters },
    dispatch: { displaySettings: displaySettingsDispatch, filters: filtersDispatch },
  } = context;

  const getCasesCancelToken = useRef<CancelTokenSource|null>(null);
  const countAllCancelToken = useRef<CancelTokenSource|null>(null);
  const countMyCancelToken = useRef<CancelTokenSource|null>(null);
  const countUnclaimedCancelToken = useRef<CancelTokenSource|null>(null);

  const getCaseData = async (): Promise<void> => {
    const { pageName } = displaySettings;
    const filterQueryString: string = getFilterQueryString(filters);
    const queryString: string = getQueryString(filterQueryString, displaySettings);
  
    getCases(queryString, getCasesCancelToken)
    .then((res) => {
      setCases(res.data || []);
      setLoadingCases(false);
    });   
    setTotalCasesCount(null);
    getCaseCount(PageName.ALL_CASES, filterQueryString, countAllCancelToken).then((res) => {
      setTotalCasesCount(res.data);
      if (pageName === PageName.ALL_CASES) {
        displaySettingsDispatch({ type: displaySettingsAction.SET_COUNT, count: res.data || 0 }); 
      } 
    });
    setMyCasesCount(null);
    getCaseCount(PageName.MY_CASES, filterQueryString, countMyCancelToken).then((res) => {
      setMyCasesCount(res.data);
      if (pageName === PageName.MY_CASES) {
        displaySettingsDispatch({ type: displaySettingsAction.SET_COUNT, count: res?.data || 0 }); 
      }
    });
    if (pageName === PageName.UNCLAIMED_CASES) {
      getCaseCount(PageName.UNCLAIMED_CASES, filterQueryString, countUnclaimedCancelToken).then((res) => {
        displaySettingsDispatch({ type: displaySettingsAction.SET_COUNT, count: res.data || 0 }); 
      });
    }
  };

  const [setupDataLoaded, setSetupDataLoaded] = useState<boolean>(false);

  const {
    pageName,
    pagination: { pageIndex, pageSize },
    sort
  } = displaySettings;
  useEffect(() => {
    if (!setupDataLoaded) {
      getTeamQStaticData().then((result) => {
        setStaticData(result.data);
        setSetupDataLoaded(true);
      });
      readLocalStorage(displaySettingsDispatch, filtersDispatch);
    }
  }, [setupDataLoaded]);

  useEffect(() => {
    if (setupDataLoaded) {
      writeLocalStorage(displaySettings, filters);
    }
  }, [filters, pageName, pageIndex, pageSize, sort]);

  useEffect(() => {
      setLoadingCases(true);
      getCaseData();
  }, [pageName, pageIndex, pageSize, sort]);

  useEffect(() => {
    if (dataLoad) {
      getCaseData();
      setDataLoad(false);
    }
  }, [dataLoad]);

  usePolling(()=>setDataLoad(true));
};
